import React from "react";
import "./SaralTransport.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import truck from "../../Images/truck.png";
import largeImage from "../../Images/servicesbg.png"; // Replace with your large image path
import smallImage from "../../Images/containers.png"; // Replace with your small image path
import why from "../../Images/whychooseus.png";
import otherproducts from "../../Images/otherproducts.png";
import Features from "../Features";
import { saralTransportFeatures, whyChooseTransport } from "../../utils/saralTransport";
import WeOffer from "../WeOffer";

const SaralTransport = () => {
  return (
    <div className="saral-transport-container">
      {/* Title Section */}
      <div className="title-section">
        <h1 className="saral-title">Saral <span>Transport</span></h1>
        <p className="saral-subtitle">
        Simplifying Logistics, Maximizing Efficiency!        </p>
      </div>
      {/* Content Section */}
      <div className="content-section">
        <div className="text-content">
          <p className="latest-work">Saral Way</p>
          <h2 className="boost-title">
          The Complete End-to-End Solution for Your <span>Transportation</span> Business
          </h2>
          <h1 className="description">
          Managing a transportation business requires efficiency, accuracy, and seamless coordination between multiple stakeholders. Saral Transport provides a comprehensive digital solution that covers the entire process—from generating a bilty to issuing a money receipt—ensuring smooth operations for transporters, consignors, and consignees.
          </h1>
        </div>
        {/* Truck Image */}
        <div className="image-content">
          <img src={truck} alt="Truck" className="truck-image" />
        </div>
      </div>
      <Features features={saralTransportFeatures}/>
      <WeOffer data={whyChooseTransport}/>
    </div>
  );
};

export default SaralTransport;
